import {EventBus, Logger} from 'esp-js';

import {LegalDocumentsService} from '../../dal';
import {LegalEvents,LegalPageDocumentsLoadedEvent} from './events';
import {LegalStoreModel} from './legalStoreModel';

const _log = Logger.create('LegalStore');

export const LEGAL_STORE_ID = 'legal-store';

export const registerLegalStore = (eventBus: EventBus, legalDocumentsService: LegalDocumentsService) => {
    eventBus.storeBuilder<LegalStoreModel>(LEGAL_STORE_ID, new LegalStoreModel())
        .withEffect(LegalEvents.documentsRequested, (model, event, eventContext, publish) => {
            legalDocumentsService.getCurrentDocuments()
                .then(documents => publish(LegalEvents.documentsLoaded, {documents} satisfies LegalPageDocumentsLoadedEvent))
                .catch(error => _log.error('Load legal documents failed', error));
        })
        .withEventHandler<LegalPageDocumentsLoadedEvent>(LegalEvents.documentsLoaded, (draft, event) => {
            draft.onDocumentsLoaded(event.documents);
        })
        .build();
};
